import {useState} from 'react';
import {useVerifyDeviceMutation} from 'src/redux/queries/device';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

export const VerifyDeviceDialogCopy = {
  title: 'Are you sure you want to verify this device?',
  body: 'This confirms the device is permanent and trusted; it will no longer be marked unverified.',
};

/**
 * Shared verify-device mutation, alerts and idempotent loading state. Used
 * by both the device table's row menu and the device detail page's action
 * button so the copy and error handling stay in one place.
 */
export function useVerifyDevice() {
  const {setAlert} = useAlert();
  const [verifyDeviceMutation] = useVerifyDeviceMutation();
  const [isVerifying, setIsVerifying] = useState(false);

  const verify = async (id: number, name?: string) => {
    setIsVerifying(true);

    try {
      await verifyDeviceMutation(id).unwrap();
      setAlert(`${name ?? 'Device'} was successfully verified.`, 'success');
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
    }

    setIsVerifying(false);
  };

  return {verify, isVerifying};
}
